/* eslint-disable import/prefer-default-export */

import {
  PODCAST_LESSON_SET_EXPANDED_LESSON,
  PODCAST_LESSON_SET_NEXT_LESSON,
  PODCAST_LESSON_RESET,
  PODCAST_LESSON_SET_IS_LOADING,
  PODCAST_LESSON_SET_PLAY_PODCAST_AUDIO,
} from '../constants';

export function setOpenedPodcastLesson(
  openedPodcastLesson,
  playPodcastAudio = false,
  shouldScrollIntoView = false,
) {
  return {
    type: PODCAST_LESSON_SET_EXPANDED_LESSON,
    openedPodcastLesson,
    playPodcastAudio,
    shouldScrollIntoView,
  };
}

export function setNextLesson(data) {
  return {
    type: PODCAST_LESSON_SET_NEXT_LESSON,
    data,
  };
}

export function setIsLoading(isLoading) {
  return {
    type: PODCAST_LESSON_SET_IS_LOADING,
    isLoading,
  };
}

export function setPlayPodcastAudio(playPodcastAudio) {
  return {
    type: PODCAST_LESSON_SET_PLAY_PODCAST_AUDIO,
    playPodcastAudio,
  };
}

export function reset() {
  return {
    type: PODCAST_LESSON_RESET,
  };
}
